import { useEffect } from 'react';

// Import hooks
import { useAppDispatch } from 'store/hooks';
import { useAuth } from 'components/utilities';

// Import actions
import { fetchSubscriberPackets } from 'store/features/subscriber/thunk';
import { fetchConfiguratorPackets } from 'store/features/configurator/packets';
import {
	fetchFavourites,
	fetchReminders,
	fetchTvPrograms,
	fetchNpvrRecordings,
	fetchTvCategory,
	fetchActiveSubscriptionsList,
	fetchGenresList,
	fetchFreeProducts
} from 'store/actions';

// Import helpers
import { isRetail } from 'helpers/operators';

// Import types
import { PacketSubtype } from 'types/api/products/product';

const useAppResources = () => {
	const dispatch = useAppDispatch();
	const { isAuth } = useAuth();

	const fetchCommonData = async () => {
		await fetchGenresList(dispatch);
		await fetchTvCategory()(dispatch);
		await fetchFreeProducts()(dispatch);
		if (isRetail) {
			await dispatch(fetchTvPrograms({ isAuth }));
			await dispatch(fetchConfiguratorPackets([PacketSubtype.Main, PacketSubtype.Premium]));
		}
	};

	const fetchAuthorizedData = async () => {
		await dispatch(fetchTvPrograms());
		await fetchActiveSubscriptionsList()(dispatch);
		await dispatch(fetchSubscriberPackets());
		await fetchFavourites()(dispatch);
		await fetchReminders()(dispatch);
		await fetchNpvrRecordings()(dispatch);
	};

	useEffect(() => {
		fetchCommonData();
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (isAuth) fetchAuthorizedData();
		//eslint-disable-next-line
	}, [isAuth]);
};

export default useAppResources;
